// latest: guozhh 2017-10-22 20:50 PM
import { Model } from 'common'
Model.define('performfeedbackType', {
  proxy: {
  },
  meta: {
    id: '', // 唯一标识
    templetId: '', // 模板ID
    indicatorId: '', // 指标ID
    indicatorName: '', // 指标名称
    orderNo: '', // 序号
    indicatorType: '', // 指标分类
    rate: '', // 衰减比率
    weight: '', // 权重
    indicatorClassName: '', // 指标名称
    addOrMinus: '', // 加减分项
    factor: '', // 衰减因子
    indicatorClassId: '' // 指标分类
  }
})

export default Model.create('performfeedbackType')



// WEBPACK FOOTER //
// ./src/data/model/performfeedbackType/index.js